import React, { useEffect, useState } from "react";
import back from "../../Asset/product/back.png";
import { useNavigate, useParams } from "react-router-dom";
import categoryModel from "../../model/category.model";
import Card from "../../component/productlist/Card";
import { useContact } from "../../useContext/ContactContext";

const SearchPage = () => {
  const Params = useParams();
  const [categoryProduct, setCategoryproduct] = useState();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { search, setSearch} = useContact();


  const GetData = async () => {
    setLoading(true);
    categoryModel
      .GetSearch(Params?.id)
      .then((responce) => {
        setCategoryproduct(responce?.data?.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log("error", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    GetData();
  }, [Params?.id]);

  useEffect(() => {
    GetData();
  }, []);


   useEffect(() => {
      if (!search) {
       navigate(`/`);
      } 
    }, [search]);


  
  return (
    <div
      className="w-full bg-Background1 pl-20 pt-20 pr-20 pb-40"
      style={{ backgroundImage: `url(${back})` }}
    >
      <div className="w-full">
        <span className="text-textColor text-xl font-semibold">
          Search Item
        </span>
      </div>
      <div className="mt-6">
  {!loading ? (
    categoryProduct && categoryProduct.length > 0 ? (
      <div className="mt-8 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 xl:gap-5 2xl:gap-8">
        {categoryProduct.map((item, index) => (
          <Card item={item} key={index} />
        ))}
      </div>
    ) : (
      <div className="w-full h-[200px] flex justify-center py-24 text-xl font-semibold text-gray-500">
        No Product Found
      </div>
    )
  ) : (
    <div className="w-full h-[200px] flex justify-center py-24">
      wait
      <span className="loading loading-ball loading-xs"></span>
      <span className="loading loading-ball loading-sm"></span>
      <span className="loading loading-ball loading-md"></span>
      <span className="loading loading-ball loading-lg"></span>
      <span className="loading loading-ball loading-xl"></span>
    </div>
  )}
</div>
    </div>
  );
};

export default SearchPage;
